import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import * as fromCustomersActions from '../actions/app.action';

import { from, Observable, of } from 'rxjs';
import { switchMap, map, catchError, mergeMap } from 'rxjs/operators';
import { ApiService } from 'src/app/services/api.service';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class AppEffects {

  constructor(
    private action$: Actions,
    private api: ApiService,
  ) {

  }

  // load Customer
  @Effect()
  loadCustomers$ = this.action$.pipe(
    ofType(fromCustomersActions.LOAD_CUSTOMERS),
    mergeMap(async () => {
      let dispatch: Action[] = [];
      let response:any;
      try {
        const filter = {
          where: { id: '67e6064760d64805bc1d8933' },
          include: [{
            "relation": "addresses",
            "scope": {
              "include": [
                {"relation": "city"},
                {"relation": "department"}
              ]
            }
          },
            {relation:"carts",
              scope:{
                 include: [
                     {relation:"items",
                     scope: {
                         include: ["product"]
                     }
                     }
         
                 ]
              }},
          ]
        };
      
      
        response = await this.api.get('users', { filter }).toPromise();
      
        dispatch.push(new fromCustomersActions.LoadCustomerSucess(response));
      } catch (error) {
        dispatch.push(new fromCustomersActions.LoadCustomerFail(error));
      }
      console.log("response", response);
  
      return from(dispatch); // para emitir múltiples acciones
    }),
    mergeMap(actions => actions), // descompone los arrays de acciones en emisiones individuales
    catchError((error: HttpErrorResponse) => {
      return of(new fromCustomersActions.LoadCustomerFail(error));
    })
  );

 
}